import React from "react";
import { NavLink } from "react-router-dom";

export default function NewsCard({ news }) {
  const style = {
    background:
      `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, .9)), url(${news?.imageUrl}) center/cover no-repeat`,
  };

  return (
    <article className="news_card" style={style}>
      {/* <img
        src="https://people-api.pro/uploads/11-08-2024/f3901d6afa73a5c35b076a08f44cba0e.jpg"
        alt="advert"
      /> */}
      <h4>
        title: {news?.title}
      </h4>
      <p>
       {news?.text}
      </p>
      <NavLink
        to={
          news?.refUrl
        }
        style={{
          color: "#ec642b"
        }}
      >
        Read more...
      </NavLink>
    </article>
  );
}
